const idleState = {
  isInProcess: false,
  paymentMethodNonce: null,
  type: null,
  paymentMethods: [],
}
const resetState = {...idleState, clientToken: null}
const initialState = {...resetState}

const payment = (state = initialState, {type, payload}) => {
  switch (type) {
    case 'CARD_NUMBER_PAYMENT_METHOD_RECEIVED':
      return {...state, paymentMethodNonce: payload.token, type: 'card_number'}
    case 'PAYMENT_MODAL.INIT':
    case 'TOKENIZATION_TIMEOUT':
      return {...state, ...resetState}
    case 'TOUCHLESS_PAYMENT_SUCCESS':
      return {...state, ...idleState}
    case 'PAY_VIA_CASH':
      return {...state, isInProcess: true, type: 'cash'}
    case 'PAY_VIA_ZELLE':
      return {...state, isInProcess: true, type: 'zelle'}
    case 'PAY_TOUCHLESS':
      return {...state, isInProcess: true, type: 'touchless'}
    case 'PAYMENT_CLIENT_TOKEN_RECEIVED':
      return {...state, clientToken: payload.clientToken}
    case 'CLEAR_SHOP':
      return {...state, ...idleState, needsOpenDrawer: payload && payload.receipt && payload.receipt.cash}
    case 'PAYMENT_MODAL_CLOSED':
    case 'PAYMENT_CANCELLED':
      return {...state, ...idleState}
    case 'OPEN_CASH_DRAWER':
      return {...state, needsOpenDrawer: false}
    case 'PAYMENT_METHODS_RECEIVED':
      return {...state, paymentMethods: payload}
    default:
      return state
  }
}

export default payment
